import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Router } from '@reach/router'
import {
  CssBaseline,
  MuiThemeProvider,
  createMuiTheme
} from '@material-ui/core'
import ReactGA from 'react-ga';

import config from './config'
import { Services } from './components/pages/Services'
import { isAppInitialized, hasAppGenericErrors } from './store/app/selectors'
import { LinkedSlotPicker as SlotPicker } from './components/pages/SlotPicker'
import {
  WORKFLOW_STEP_0,
  WORKFLOW_STEP_1,
  WORKFLOW_STEP_2,
  WORKFLOW_STEP_FINISHED
} from './store/workflow/constant'
import { LinkedClientData as ClientData } from './components/pages/ClientData'
import { LinkedSuccess } from './components/pages/Success'
import { Loading } from './components/atoms/Loading'
import { getThemeColor } from './store/garage/selectors'
import { LinkedErrorPage as ErrorPage } from './components/pages/ErrorPage'
import { appInitError } from './store/app/actions'
import FaviconLoader from './components/molecules/FaviconLoader'

ReactGA.initialize(config.gaTrackingID);

class App extends Component {

  createTheme = () => {
    try {
      return createMuiTheme({
        palette: {
          primary: {
            main: this.props.themeColor
          }
        },
        typography: {
          useNextVariants: true
        }
      })
    } catch (e) {
      this.props.appInitError(e)
    }
  }

  render() {
    const { isInitialized, hasErrors } = this.props
    if (hasErrors) {
      return <ErrorPage />
    }
    if (!isInitialized) {
      return <Loading />
    }
    return (
      <MuiThemeProvider theme={this.createTheme()}>
        <CssBaseline />
        <FaviconLoader />
        <Router>
          <Services path="/" default activeStep={WORKFLOW_STEP_0} />
          <SlotPicker path="/seleziona-data" activeStep={WORKFLOW_STEP_1} />
          <ClientData path="/form-cliente" activeStep={WORKFLOW_STEP_2} />
          <LinkedSuccess path="/success" activeStep={WORKFLOW_STEP_FINISHED} />
        </Router>
      </MuiThemeProvider>
    )
  }
}

const mapStateToProps = state => ({
  isInitialized: isAppInitialized(state),
  hasErrors: hasAppGenericErrors(state),
  themeColor: getThemeColor(state)
})

const mapDispatchToProps = dispatch => ({
  appInitError: error => dispatch(appInitError(error))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)
